import {IconColor} from "../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import Attachment from "../attachment/Attachment";
import * as moment from "moment";

/**
 * ActivityEvent class for common activity stream (extended by LeadEvent and JobEvent)
 */
export default class ActivityEvent {

	getCssClass(differentContext?: boolean): string {
		throw new Error('NOT IMPLEMENTED METHOD');
	}

	getIcon(): string {
		throw new Error('NOT IMPLEMENTED METHOD');
	}

	getIconColor(): IconColor {
		throw new Error('NOT IMPLEMENTED METHOD');
	}

	getAttachments(): Attachment[] {
		throw new Error('NOT IMPLEMENTED METHOD');
	}

	getActivityAdditionalMessages(): string[] {
		throw new Error('NOT IMPLEMENTED METHOD');
	}

	getActivityType(differentContext?: boolean): string {
		throw new Error('NOT IMPLEMENTED METHOD');
	}

	getActivityMessage(): string {
		throw new Error('NOT IMPLEMENTED METHOD');
	}

	getCreationDate(): moment.Moment {
		throw new Error('NOT IMPLEMENTED METHOD');
	}

	getUserDisplayName(): string {
		throw new Error('NOT IMPLEMENTED METHOD');
	}

	getId(): string {
		throw new Error('NOT IMPLEMENTED METHOD');
	}
}